'use strict';

module.exports = parseInt(process.env.NODE_UNIQUE_ID || 0, 10);
